import React from "react";

import { useCookieConsentContext } from "./CookieConsentContext";
import { CookieConsentFab } from "./CookieConsentFab";
import { CookieConsentDrawer } from "./CookieConsentDrawer";
import { CookieConsentDialog } from "./CookieConsentDialog";

/**
 * This is a container for a simple consent banner, which allows a user
 * to accept or reject tracking cookies (and similar technologies).
 *
 * It coordinates the following components, responsible for providing the
 * user with controls and information:
 *
 * - CookieConsentDrawer
 * - CookieConsentDialog
 *
 * Additional future work might include:
 *
 * - finer-grained preference setting, if we develop use cases for it
 * - invalidating consent already given in circumstances where the basis for
 *   consent may have changed
 */
export const CookieConsentWorkflow = ({ showFab = false }) => {
  const {
    acceptAll,
    closeDialog,
    externalCookiePolicyUrl,
    isDialogOpen,
    isDrawerOpen,
    readMore,
    rejectAll,
    reviewResponse,
  } = useCookieConsentContext();

  return (
    <>
      {showFab &&
        (isDrawerOpen ? null : <CookieConsentFab onClick={reviewResponse} />)}
      <CookieConsentDrawer
        isOpen={isDrawerOpen}
        onRejectAll={rejectAll}
        onAcceptAll={acceptAll}
        onReadMore={readMore}
      />
      {externalCookiePolicyUrl ? null : (
        <CookieConsentDialog
          isOpen={isDialogOpen}
          onRejectAll={rejectAll}
          onAcceptAll={acceptAll}
          onCloseDialog={closeDialog}
        />
      )}
    </>
  );
};
